import { MyAccountRoute } from "@/constants/routes/myAccount.ts"
import nativeHelper from "@/lib/nativeHelper.ts"
import { isSoChatEnabled, soChat } from "@/plugins/soChat.ts"

/**
 * Opens the chat from a "chat with us" link: So Energy's widget on the website, and the chat
 * screen in the native app, which has no widget of its own.
 */
export const openWebchat = () => {
  if (nativeHelper.isNative()) {
    globalThis.location.assign(MyAccountRoute.chat)
    return
  }
  if (isSoChatEnabled()) soChat("open")
}
